<template>
	<el-scrollbar ref="sw" :height="height">
		<slot name="default" :height="height" :element="scrollbarEl"></slot>
	</el-scrollbar>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { ElScrollbar } from 'element-plus';

@Options({
	components: {
		ElScrollbar
	},
	props: {
		autoHeight: {
			type: Boolean,
			default: true
		},
		strictHeight: {
			type: Number,
			default: null
		},
		minHeight: {
			type: Number,
			default: null
		}
	}
})
export default class ScrollviewComponent extends Vue {
	/** props */
	autoHeight!: boolean;
	strictHeight!: number | null;
	minHeight!: number | null;

	/** view-models */
	scrollbarEl : HTMLElement | null = null;
	height = '0px';

	mounted(): void {
		const sw = this.$refs.sw as any;
		this.scrollbarEl = sw.wrapRef as HTMLElement;
		
		addEventListener('resize', this.onWindowResize);
		window.dispatchEvent(new Event('resize'));
	} 

	unmounted(): void {
		removeEventListener('resize', this.onWindowResize);
	}

	onWindowResize() {
		if (!this.scrollbarEl) {
			console.error('Error initializing ScrollviewComponent: scrollbar element reference is null');
			return;
		}		

		if (this.strictHeight) {
			this.height = `${Math.round(this.strictHeight)}px`;
			return;
		}

		const windowHeight = document.body.offsetHeight;
		const scrollHeight = windowHeight - this.scrollbarEl.getBoundingClientRect().top;

		if (this.minHeight) {
			this.height = `${Math.round(scrollHeight < this.minHeight ? this.minHeight : scrollHeight)}px`;
		} else {
			this.height = `${Math.round(scrollHeight)}px`;
		}		
	}
}
</script>